import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import Icon from '../Icon';

interface IProps {
  text: string | JSX.Element;
  variant: 'success' | 'info' | 'error';
}

const ToastMessage: FunctionComponent<IProps> = ({ variant, text }) => {
  const getIconName = () => {
    switch (variant) {
      case 'success':
        return 'checkCircle';
      case 'info':
        return 'downloadCircle';
      case 'error':
      default:
        return 'caution';
    }
  };

  return (
    <>
      <div>
        <Icon icon={getIconName()} className={styles.icon} />
      </div>
      <span className={styles.text}>
        {text}
      </span>
    </>
  );
};

export default ToastMessage;
